import api from './api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function buildSubscriptionData(subscription) {
  return {
    endpoint: subscription.endpoint,
    p256dh: btoa(String.fromCharCode(...new Uint8Array(subscription.getKey('p256dh')))),
    auth: btoa(String.fromCharCode(...new Uint8Array(subscription.getKey('auth')))),
    userAgent: navigator.userAgent,
  };
}

export async function registerForPush() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.warn('Push notifications not supported');
    return null;
  }

  try {
    if (Notification.permission === 'denied') {
       return null;
    }

    const permission = Notification.permission === 'default'
      ? await Notification.requestPermission()
      : Notification.permission;

    if (permission !== 'granted') {
       return null;
    }

    let registration = await navigator.serviceWorker.getRegistration();
    if (!registration) {
      await navigator.serviceWorker.register('/sw.js');
      registration = await navigator.serviceWorker.ready;
    } else {
      registration = await navigator.serviceWorker.ready;
    }

    const existingSubscription = await registration.pushManager.getSubscription();
    if (existingSubscription) {
      const subscriptionData = buildSubscriptionData(existingSubscription);
      await api.post('/notifications/subscribe', subscriptionData);
      return existingSubscription;
    }

    // Get VAPID public key from server
    const vapidResponse = await api.get('/notifications/vapid-public-key');
    const vapidKey = vapidResponse.data.publicKey;

    if (!vapidKey) {
      console.error('VAPID public key not available');
      return null;
    }

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidKey),
    });

    // Send subscription to server
    const subscriptionData = buildSubscriptionData(subscription);

    await api.post('/notifications/subscribe', subscriptionData);
     return subscription;
  } catch (err) {
    console.error('registerForPush failed', err);
    return null;
  }
}

export async function unregisterPush() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

  try {
    const reg = await navigator.serviceWorker.getRegistration();
    if (!reg) return;

    const subscription = await reg.pushManager.getSubscription();
    if (!subscription) return;

    const endpoint = subscription.endpoint;

    // Unsubscribe from server
    await api.delete('/notifications/unsubscribe', { data: { endpoint } });

    // Unsubscribe from browser
    await subscription.unsubscribe();
   } catch (err) {
    console.error('unregisterPush failed', err);
  }
}

export async function isPushSubscribed() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return false;
  if (Notification.permission !== 'granted') return false;
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    if (!reg) return false;

    const subscription = await reg.pushManager.getSubscription();
    return !!subscription;
  } catch (err) {
    console.error('isPushSubscribed check failed', err);
    return false;
  }
}
